import {defineStore} from "pinia";
import http from "../api/http";
import {useUser} from "./user";
import {ElMessage} from "element-plus";
import ClipboardJS from "clipboard";

export const useSystem = defineStore('system', {
    state: () => ({
        systemInfo: [],
        website: {},
        bannerList: [], // 轮播列表
        isMobile: false, // 鉴别是否是手机模式
        isOpenMenu: false, //手机显示时监听菜单的点击
        paymentList: [], //支付方式
        withdrawList: [], //提现方式
        front_module_list: [], //显示页面的模块中的内容
        langList: [], //多语言列表
        currentShortMenu: 1, //快捷菜单,
        virtualWithdrawList: [],
        clipboard: null
    }),
    getters: {
        getSystemInfo: (state) => state.systemInfo,
        getWebsite: (state) => state.website,
        getBannerList: (state) => state.bannerList,
        getIsMobile: (state) => state.isMobile,
        getIsOpenMenu: (state) => state.isOpenMenu,
        getPaymentList: (state) => state.paymentList,
        getWithdrawList: (state) => state.withdrawList,
        getFrontModuleContent: (state) => (front_module_id, index=0) =>  {
            // front_module_id 为 number类型
            if (index === 0) {
                let module_content = state.front_module_list.find(item => item.front_module_id === front_module_id)
                // console.log(123123, module_content)
                return module_content? module_content : false
            }else {
                let module_contents = state.front_module_list.filter(item => item.front_module_id === front_module_id)
                return module_contents? module_contents[index] : false
            }

        },
        getBlockIconColor: (state) => () => {
            let colors = [
                'block-icon--purple', 'block-icon--orange', 'block-icon--green', 'block-icon--blue',
                'block-icon--red', 'block-icon--yellow'
            ]
            let index = Math.floor(Math.random() * colors.length)
            return colors[index]
        },
        getRandomColor: (state) => () => {
            let colors = [
                'purple', 'orange', 'green', 'blue',
                'red', 'yellow'
            ]
            let index = Math.floor(Math.random() * colors.length)
            return colors[index]
        },
        getStatsDodgerColor: (state) => () => {
            let colors = [
                'stats__dodger--purple', 'stats__dodger--orange', 'stats__dodger--green', 'stats__dodger--blue',
                'stats__dodger--red', 'stats__dodger--yellow'
            ]
            let index = Math.floor(Math.random() * colors.length)
            return colors[index]
        },
        getDotsLineColor: (state) => () => {
            let colors = [
                'dots--line-orange', 'dots--line-purple', 'dots--line-green', 'dots--line-blue',
                'dots--line-red', 'dots--line-yellow'
            ]
            let index = Math.floor(Math.random() * colors.length)
            return colors[index]
        },
        getLangList: (state) => state.langList,
        getVirtualWithdrawList: (state) => state.virtualWithdrawList,
    },
    actions: {
        setMenuIsOpen(isOpen) {
            this.isOpenMenu = isOpen
        },
        setIsMobile(isMobile) {
            this.isMobile = isMobile
        },
        systemInfoApi() {
            http.getSystemBasicsInfo().then((res) => {
                this.systemInfo = res.data

                for (let item of res.data) {
                    this.website[item.name] = item.value
                }
            }).catch((err) => {
                console.log("request error:", err)
            })
            this.langListApi()
        },
        langListApi() {
          http.langList().then(res => {
              this.langList = res.data
          })
        },
        logoutApi(router) {
            http.logout().then(res => {
                useUser().clearToken()
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {
                        window.localStorage.removeItem("mine-token")
                        router.push({path: '/'})
                    }
                })
            }).catch(err => {
                console.log(err)
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {
                        window.localStorage.removeItem("mine-token")
                        router.push({path: '/'})
                    }
                })
            })
        },
        emailRegisterApi(data, router) {
            http.emailRegister(data).then(res => {
                if (res.data && res.data.userinfo) {
                    useUser().setToken(res.data.userinfo.token)
                    ElMessage({
                        duration: 1500,
                        message: res.msg,
                        type: 'success',
                        onClose: () => {
                            router.push({path: '/Signin'})
                        }
                    })
                }
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        emailLoginApi(data, router) {
            http.emailLogin(data).then(res => {
                if (res.data && res.data.userinfo) {
                    useUser().setToken(res.data.userinfo.token)
                    ElMessage({
                        duration: 1500,
                        message: res.msg,
                        type: 'success',
                        onClose: () => {
                            router.push({path: '/'})
                        }
                    })
                }
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        emailResetPwd(data, router) {
            http.resetPwd(data).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {
                        router.push({path: '/Signin'})
                    }
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        emailForgetPwd(data, router) {
            http.forgetPwd(data).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {
                        router.push({path: '/Signin'})
                    }
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        emailCodeSendApi(params) {
            http.emailCodeSend(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        bannerApi() {
            http.bannerList().then(res => {
                this.bannerList = res.data
            })
        },
        withdrawalMethodListApi() {
            http.withdrawalMethodList().then(res => {
                this.withdrawList = res.data
            })
        },
        getPaymentListApi() {
          http.paymentList().then(res => {
              this.paymentList = res.data
          })
        },
        frontModuleListApi() {
          http.frontModuleList().then(res => {
              this.front_module_list = res.data
          })
        },
        // 汇率换算接口  回调返回
        currencyConversionApi(amount, coin_symbol, cb = () => {}) {
            http.currencyConversion({amount, coin_symbol}).then(res => {
                cb(res.data.exchange_amount)
            }).catch(err => {
                cb(0)
            })
        },
        //获取虚拟提现数据
        virtualWithdrawListApi() {
            http.virtualWithdraw().then(res => {
                this.virtualWithdrawList = res.data
            })
        },
        async contactsUsApi(params) {
            await http.contactsUs(params).then(res => {
                ElMessage({
                    duration: 1500,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {}
                })
            }).catch(err => {
                ElMessage({
                    duration: 1500,
                    message: err.msg,
                    type: 'error',
                    onClose: () => {}
                })
            })
        },
        //拷贝文本 必须在 onMounted中
        copyTxt(ele, txt, successMsg, errorMsg, isDestory=false) {
            if (this.clipboard) {
                this.clipboard.destroy()
            }
            this.clipboard = new ClipboardJS('.copyBtn', {
                text() {
                    return txt
                }
            })
            this.clipboard.on("success", () => {
                ElMessage({
                    duration: 1500,
                    message: successMsg,
                    type: 'success',
                    onClose: () => {
                        // if (isDestory) {
                        //     clipboard.destroy()
                        // }
                    }
                })
            });
            this.clipboard.on("error", () => {
                ElMessage({
                    duration: 1500,
                    message: errorMsg,
                    type: 'error',
                    onClose: () => {
                        // if (isDestory) {
                        //     clipboard.destroy()
                        // }
                    }
                })
            });
        },
        formatDate(timestamp, type="Y-m-d") {
            const date = new Date(timestamp * 1000); // 使用时间戳创建 Date 对象
            const year = date.getFullYear(); // 获取年份
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份并补充为两位数
            const day = String(date.getDate()).padStart(2, '0'); // 获取日期并补充为两位数
            const hours = String(date.getHours()).padStart(2, '0'); // 获取小时并补充为两位数
            const minutes = String(date.getMinutes()).padStart(2, '0'); // 获取分钟并补充为两位数
            const seconds = String(date.getSeconds()).padStart(2, '0'); // 获取秒并补充为两位数

            if (type === "Y-m-d") {
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }else{
                return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
            }

        }
    }
})
